"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
exports._QueueConfigurationDeprecated = {
    type: "structure",
    required: [],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        Event: {
            shape: {
                type: "string"
            }
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        Queue: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_QueueConfigurationDeprecated.js.map